import React, { Component } from 'react'
import { FlexContainer } from '../../styles/defaults.js'

import EmployeeCTA from '../EmployeeCTA/'
import SimpleCTA from '../SimpleCTA/'

import { Half } from './styles'

class DoubleCTA extends Component {
  render() {
    return (
      <FlexContainer full mt mb>
        {this.props.content.map((content, index) => {
          return (
            <Half key={index}>
              {content.employee ? <EmployeeCTA content={content} /> : <SimpleCTA content={content} />}
            </Half>
          )
        })}
      </FlexContainer>
    )
  }
}

export default DoubleCTA



// WEBPACK FOOTER //
// ./src/components/DoubleCTA/index.js